import React, {useMemo} from 'react';

import PaginatedContent from 'brandComponents/PaginatedContent';

import {IPaginatedContentContentfulProps} from './IPaginatedContentContentful';

const PaginatedContentContentful = (props: IPaginatedContentContentfulProps) => {
	const items = props?.contentCollection?.items || [];
	const id = props?.sys?.id;

	// Check if we only have columns
	const hasOnlyColumns = useMemo(
		() => items.every((item) => item?.__typename === 'GridColumn'),
		[props]
	);

	return props.children ? (
		<PaginatedContent id={id} isOnlyColumns={hasOnlyColumns}>
			{props.children}
		</PaginatedContent>
	) : (
		<></>
	);
};

export default PaginatedContentContentful;
